<template>
    <div>
        <div class="card-body" style="background-color: white;">
                <div class="container">
                    <div class="row">
<!--                        <div class="col-12">-->
<!--                            <label class="my-4" style="">How will the data flow?</label>-->
<!--                        </div>-->

                        <div class="col-md-4 float-left text-right">
                            <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                        </div>

                        <div class="col-md-4 float-left text-center">
                            <img class="and-logic-logo mt-4 pt-3" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/and-logic-new.png">
                        </div>
                        <div class="col-md-4 float-left text-left">
                            <img style="width: 150px; margin-top: 37px;" :src="returnUrl('sage-300-cre')">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label class="my-4">Module Mapping </label>
                        </div>
                        <div class="col-12" style="">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="col-3">Followup Module</th>
                                        <th class="col-3 capitalize">Sage 300 CRE Module</th>
                                        <th class="col-3" >Field Mapping</th>
                                        <th class="col-1">ON/OFF</th>
                                        <th class="col-2">Import</th>
                                        <th class="col-1 text-center">Add/Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, moduleIndex) in modules" :key="moduleIndex">
                                        <td>
                                            <div v-if="item.id !== 0" class="capitalize">
                                               {{item.followUp.replace(/-/g , ' ')}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="item.followUp"
                                                :options="followupObjectOption"
                                                value-field="value"
                                                text-field="label"
                                                @change="changeModules(item, 'followup', moduleIndex)"
                                                ></b-form-select>
                                                <!-- disabled-field="disabled" -->
                                        </td>
                                        <td>
                                            <div v-if="item.id !== 0">
                                                {{item.thirdPartyLabel}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="item.thirdParty"
                                                :options="thirdPartyObjectOptions"
                                                value-field="value"
                                                text-field="label"
                                                @change="changeModules(item, 'thirdParty', moduleIndex)"
                                                ></b-form-select>
                                                <!-- disabled-field="disabled" -->
                                        </td>
                                        <td>
                                           <div class="btn-link cursor-pointer" @click="viewFieldsMapping(item, moduleIndex)">View Mapped Fields</div>
                                        </td>
                                        <td>
                                            <span v-if="isRequiredFieldsMapped(item)" :title="'Map all required fields within the module to turn this on'" class="tooltipElement hover:cursor-pointer">
                                                <b-form-checkbox :disabled="isRequiredFieldsMapped(item)" v-model="item.status" switch @change="updateFieldStatus(item)"></b-form-checkbox>
                                            </span>
                                            <span v-else>
                                                <b-form-checkbox :disabled="isRequiredFieldsMapped(item)" v-model="item.status" switch @change="updateFieldStatus(item)"></b-form-checkbox>
                                            </span>
                                        </td>
                                        <td v-if="item.fieldMappings.length === 0">
                                            <button
                                                disabled="disabled"
                                                v-if="item.followUp == 'Company' || item.followUp == 'Residential-contact'"
                                                type="button"
                                                class="btn btn-sm text-xs btn-secondary cursor-not-allowed import-button-disabled tooltipElement"
                                                @click.prevent="openImportCustomersModal(item)"
                                                title="Please map the mandatory fields to import customers">
                                                Import Customers
                                            </button>
                                        </td>
                                        <td v-else>
                                            <button
                                                v-if="item.followUp == 'Company' || item.followUp == 'Residential-contact'"
                                                type="button"
                                                class="btn btn-sm text-xs btn-primary"
                                                @click.prevent="openImportCustomersModal(item)">
                                                Import Customers
                                            </button>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-danger"
                                                    @click.prevent="manageModuleDeletion(item, moduleIndex)">
                                                Delete
                                            </button>

                                            <!-- <button v-else type="button" class="btn" :class="item.fieldMappings.length === 0 ? 'btn-secondary' : 'btn-primary'" :disabled="item.fieldMappings.length === 0 || isAddButtonDisabled"
                                                    @click.prevent="saveModule(item)">
                                                Add
                                            </button> -->
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
<!--                            <div v-if="showButtonMapping && modules.length < 3" class="w-100 text-right">-->
                            <div class="w-100">
                                <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav rounded-full hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                        @click.prevent="syncSetting()">
                                    Sync Settings
                                </button>
                                <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav rounded-full hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                        @click.prevent="syncSettingLogs()">
                                    Sync Logs
                                </button>
                                <button
                                    v-if="modules.length < 4"
                                    type="button"
                                    class="btn btn-primary float-right"
                                    @click.prevent="addModuleMappingData()">
                                    Add Mapping
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <b-modal id="fieldsMappingModal" size="xl" title="Field Mapping" :hide-footer="true" v-model="showFieldsMapping" no-close-on-backdrop @hide="onModalClose()">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showFieldsMapping = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchFields">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-white ml-4 text-xl ">{{ loadingMessage}}</span>
                </div>
            </div>
            <div class="container">
<!--                <h3>Field Mapping </h3>-->
                <div class="row">
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold capitalize">
                        {{ selectedModule.followUp.replace(/-/g , ' ') }}
                    </div>

                    <div class="col-md-4 float-left text-center">
                        <button type="button" @mouseenter="returnUrlHover(selectedModule.direction)" @mouseleave="returnUrlDirection(selectedModule.direction)" @click="changeModuleDirection()" style="outline: none; border-radius: 5px;background-color: white;">
                            <img id="directionModuleUrl" style="width: 70px" :src="selectedModule.directionUrl">
                        </button>
                    </div>
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold">
                        {{ selectedModule.thirdPartyLabel}}
                    </div>
                </div>
                <div>
                    <table class="table table-bordered mt-4">
                        <thead>
                            <tr>
                                <th class="col-3">Followup Field</th>
                                <th class="col-2 text-center">Direction</th>
                                <th class="col-3 capitalize">Sage 300 CRE Field</th>
                                <th class="col-1">ON/OFF</th>
                                <th class="col-1">Add/Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fieldItem, index) in selectedModuleFields" :key="fieldItem.id" :id="fieldItem.id">
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{fieldItem.followUpLabel}} <span v-if="selectedModule.followUp == 'Company' && fieldItem.followUpObject == 'CompanyContact'"> (Contact)</span>
                                    </div>
                                    <b-form-select
                                        v-else
                                        v-model="fieldItem.followUp"
                                        @change="changeFields(fieldItem, 'followup', index)"
                                        disabled-field="disabled"
                                        filter>
                                        <b-form-select-option-group v-for="(group, index) in computedFollowUpFieldsOptions" :label="group.label" :key="index">
                                            <b-form-select-option
                                                v-for="(option, optIndex) in group.options"
                                                :key="optIndex"
                                                :value="option.value">
                                                {{ option.label }}
                                            </b-form-select-option>
                                        </b-form-select-option-group>
                                    </b-form-select>
                                </td>
                                <td class="text-center">

                                    <button v-if="fieldItem.canChangeDirection && selectedModule.direction == 'two-ways'" @mouseenter="returnUrlHoverField(fieldItem, index)" @mouseleave="returnUrlDirectionField(fieldItem, index)" type="button" class="tooltips-direction-class tooltipElement" data-toggle="tooltip" data-placement="top" title="" @click="changeModuleFieldDirection(fieldItem, index)">
                                        <img :id="'directionModuleUrlField'+fieldItem.id" style="width: 30px" :src="fieldItem.directionUrl">
                                    </button>
                                    <img v-else-if="fieldItem.canChangeDirection && selectedModule.direction !== 'two-ways'" class="tooltips-direction-class tooltipElement" style="width: 30px" :src="fieldItem.directionUrl" data-toggle="tooltip" data-placement="top" :title="returnToolTip(fieldItem.direction)">
                                    <img v-else class="tooltips-direction-class tooltipElement" style="width: 30px" :src="returnUrl('one-way-followup-latest')" data-toggle="tooltip" data-placement="top"  :title="'Data cannot be pushed to this Sage 300 field. It can only be pulled in'">

                                    <button v-if="isDropDownField(fieldItem) && ['JSTATUS', 'JEXTRAS', 'CSTATUS' ,'CTYPEA' , 'UTYPE'].includes(fieldItem.thirdPartyLabel)" @click.prevent="showDropDownFieldOptions(fieldItem, index)" class="btn btn-sm btn-success ml-3">{{ fieldItem.is_custom_field_synced ? 'Map Fields':'Map Fields' }}</button>
                                </td>
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{ getSafe(() => computedThirdPartyFieldsOptions.find(option => option.label == fieldItem.thirdPartyLabel).description) || fieldItem.thirdPartyLabel }}
                                    </div>
                                    <b-form-select
                                        v-else
                                        v-model="fieldItem.thirdParty"
                                        :options="thirdPartyFieldsOptions"
                                        value-field="value"
                                        text-field="description"
                                        @change="changeFields(fieldItem, 'thirdParty', index)"
                                        :disabled="manageFieldDisableForRequiredFields(fieldItem)"
                                        filter
                                    ></b-form-select>
                                </td>
                                <td>
                                    <b-form-checkbox
                                        v-model="fieldItem.status"
                                        :disabled="manageFieldDisableForRequiredFields(fieldItem)"
                                        :class="manageFieldDisableForRequiredFields(fieldItem) ? 'disabled-opacity' : ''"
                                        switch>
                                    </b-form-checkbox>
                                </td>
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index" class="flex justify-content-between">
                                        <button type="button" class="btn btn-warning btn-sm"  @click.prevent="editModuleField(index)">
                                            Edit
                                        </button>
                                        <button :title="isFieldRequiredToolTip(fieldItem)"
                                                data-toggle="tooltip" data-placement="top"
                                                type="button"
                                                class="btn btn-danger btn-sm tooltip-delete-field-mapping"
                                                @click.prevent="removeModuleField(index)"
                                                :disabled="manageFieldDisableForRequiredFields(fieldItem)">
                                            Delete
                                        </button>
                                    </div>
                                    <div v-else>
                                        <div class="flex justify-content-between">
                                            <button v-if="editingModuleFieldIndex === index" type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                                Update
                                            </button>
                                            <button v-else type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                                Add
                                            </button>
                                            <button :title="isFieldRequiredToolTip(fieldItem)"
                                                    data-toggle="tooltip" data-placement="top"
                                                    type="button"
                                                    class="btn btn-danger btn-sm tooltip-delete-field-mapping"
                                                    @click.prevent="removeModuleField(index)"
                                                    :disabled="manageFieldDisableForRequiredFields(fieldItem)">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <div v-if="selectedModuleFields.length < computedThirdPartyFieldsOptions.length" class="w-100 text-right">
                        <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav rounded-full hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                @click.prevent="addModuleFieldMappingData()">
                            {{ selectedModuleFields.length === 0 ?'Map field': 'Map another field' }}
                        </button>
                    </div>

                    <div class="text-md mb-3">{{ fieldMappingNote }}</div>
                    <div class="text-sm text-danger" v-if="fieldMappingError">{{fieldMappingError}}</div>
                </div>
            </div>
        </b-modal>

        <b-modal id="syncedFieldOptions" size="lg" centered title="Map Dropdown" :hide-footer="true" v-if="selectedFieldItem" v-model="dropDownOptionsModal" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="dropDownOptionsModal = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchFieldOptions">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-white ml-4 text-xl ">{{loadingDropdownOptionsMessage}}</span>
                </div>
            </div>
            <div class="container" style="height: 80vh;overflow-y: auto;">
                <div class="row">

                    <table class="table table-bordered mt-4">
                        <thead>
                            <tr>
                                <th class="col-3">{{getSafe(() => selectedFieldItem.followUpLabel)}}</th>
                                <th class="col-3">{{getSafe(() => selectedFieldItem.thirdPartyLabel)}} (Sage300)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dropDownMapping, index) in selectedFieldDropdowns" :key="dropDownMapping.id" :id="dropDownMapping.id">
                                <td>
                                    <b-form-select
                                        v-model="dropDownMapping.followup_field_id"
                                        value-field="id"
                                        text-field="name"
                                        :options="followupFieldOptions"
                                        filter
                                        @change="changeDropdownMappingField(index, dropDownMapping, 'follow_up')"
                                        ></b-form-select>
                                </td>
                                <td>
                                    <b-form-select
                                        v-model="dropDownMapping.agave_field_id"
                                        value-field="id"
                                        text-field="name"
                                        :options="agaveFieldOptions"
                                        @change="changeDropdownMappingField(index, dropDownMapping, 'thirdParty')"
                                    ></b-form-select>
                                </td>

                            </tr>
                        </tbody>
                    </table>

                    <div class="w-100 text-right">
                        <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                @click.prevent="saveDropdownOptions()">
                            Save
                        </button>
                    </div>

                </div>
            </div>
        </b-modal>

        <div class="modal" tabindex="-1" role="dialog" id="importCustomerConfirmationModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Import all Sage 300 customers?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will import all the customers from Sage 300, as per the fields mapped. Do you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeImportCustomersModal()">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="importCustomers()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <erp-sync-setting
            ref="ErpSyncSetting"
            :erpIntegrationId="erpIntegrationId"
            :connectedErpIntegration="connectedErpIntegration"
            :module-mappings="modules">
        </erp-sync-setting>

        <erp-sync-setting-logs
            ref="ErpSyncSettingLogs"
            erpIntegrationName="Sage 300 CRE"
            :erpIntegrationId="erpIntegrationId"
            :connectedErpIntegration="connectedErpIntegration">
        </erp-sync-setting-logs>

    </div>
</template>


<script>

import axios from 'axios';
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import {sage300ProjectFields,sage300ContactFields, sage300CompanyFields, sage300AgaveFields, sage300ProjectContactFields } from "../../../constants"
import ErpSyncSetting from "./erp-sync-setting.vue";
import ErpSyncSettingLogs from "./erp-sync-setting-logs.vue";

export default {

    name: 'erp-integration-sage300-settings',
    components: {ErpSyncSettingLogs, ErpSyncSetting, Multiselect},
    props: ['team', 'bucketUrl', 'connectedErpIntegration'],
    data() {
        return {
            erpIntegrationId: 0,
            direction:'two-ways',
            fieldDirection:'two-ways',
            // showButtonMapping: true,
            // showFieldButtonMapping: true,
            modules: [],
            selectedModuleFields: [],
            followupObjectOption:[
                {custom_id: 1, value:'Project', label:'Project', disabled: false},
                {custom_id: 2, value:'Company', label:'Company', disabled: false},
                {custom_id: 3, value:'Residential-contact', label:'Residential Contact', disabled: false},
                {custom_id: 4, value:'Project-change-order', label:'Project | Change Orders', disabled: false}
            ],
            thirdPartyObjectOptions:[
                {value:'MASTER_JCM_RECORD_1', label:'Job Cost', disabled: false},
                {value:'MASTER_ARM_RECORD_1', label:'Accounts Receivable (for Company)', disabled: false},
                {value:'STANDARD_ARS_RECORD_1', label:'Accounts Receivable (for Residential Contact)', disabled: false},
                {value:'CHANGE_ORDER', label:'Change Order', disabled: false},
            ],
            showFieldsMapping: false,
            showSaveFieldsButton: false,
            selectedModule: {
                followUp: '',
                thirdParty: '',
                direction: 'two-ways',
                directionUrl: '',
                fieldMappings: [],
            },
            selectedModuleIndex: null,
            followUpFieldsOptions: [],
            projectFields: sage300ProjectFields,
            contactFields: sage300ContactFields,
            companyFields: sage300CompanyFields,
            projectContactFields: sage300ProjectContactFields,
            residentialContactFields: [
                {is_dropdown_field: false, value:'address', label:'Address', disabled: false, object_type:'CompanyContact'},
                {is_dropdown_field: false, value:'city', label:'City', disabled: false, object_type:'CompanyContact'},
                {is_dropdown_field: false, value:'state', label:'State', disabled: false, object_type:'CompanyContact'},
                {is_dropdown_field: false, value:'zip', label:'Zip Code', disabled: false, object_type:'CompanyContact'},
            ],
            projectChangeOrderFields: [
                {is_dropdown_field: false, value:'name', label:'Change Order Name', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: false, value:'base_bid', label:'Base Bid', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: false, value:'contract_amount', label:'Contract Amount', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: false, value:'contract_date', label:'Contract Date', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: false, value:'bid_date', label:'Bid Date', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: false, value:'gross_margin_percentage', label:'Gross Margin%', disabled: false, object_type:'ProjectChangeOrder'},
                {is_dropdown_field: true, value:'sales_status_id', label:'Sales Status', disabled: false, object_type:'ProjectChangeOrder'},
            ],
            thirdPartyFieldsOptions: [],
            // Todo pull this from constants
            agaveFields: sage300AgaveFields,
            projectCustomFields: [],
            companyCustomFields: [],
            contactCustomFields: [],
            fieldMappingError: null,
            loadingMessage: 'Fetching fields',
            dropDownOptionsModal: false,
            followupFieldOptions: [],
            agaveFieldOptions: [],
            selectedFieldItem: null,
            selectedFieldIndex: null,
            selectedFieldDropdowns: [],
            loadingDropdownOptionsMessage: 'Fetching dropdown options',
            editingModuleFieldIndex: null,
            selectedModuleForImport: null,
            isAddButtonDisabled: false,
            fieldMappingNote: '',
            projectSalesBehaviors: [],
            recordDetailCustomFields: [],
            changeOrderCustomFields: []
        };
    },
    watch: {

    },
    async mounted() {
        await this.getErpIntegrations();
        this.getProjectCustomFields();
        this.getRecordDetailCustomFields();
        this.getCompanyCustomFields();
        this.getContactCustomFields();
        this.getSalesBehaviors();
        this.getChangeOrderCustomFields();

        this.selectedModule.directionUrl = this.bucketUrl+'erp/'+this.selectedModule.direction+'-latest.png';
        this.applyToolTip();
        this.addToolTip();
    },

    methods: {
        applyToolTip(){
            $(document).ready(function() {
                setTimeout(() => {
                    $(".tooltipElement").tooltip();
                }, 500);
            });
        },
        showDropDownFieldOptions(fieldItem, fieldIndex){
            let self = this;
            self.dropDownOptionsModal = true;
            self.selectedFieldItem = fieldItem;
            self.selectedFieldIndex = fieldIndex;

            self.$nextTick(() => {
                $("#loadingOverlayFetchFieldOptions").fadeIn();
            })
            setTimeout(() => {
                $("#loadingOverlayFetchFieldOptions").fadeIn();
            }, 100)

            axios.post(route('api.erp-integration-sage300-fields.get-agave-dropdown-options'), {fieldItem: fieldItem}).then(({data}) => {
                if(data.status == 'success'){
                    self.followupFieldOptions = data.followupFieldOptions;
                    self.agaveFieldOptions = data.agaveFieldOptions;

                    //selecting the dropdown of bigger array by-defaut
                    if(self.followupFieldOptions.length > self.agaveFieldOptions.length ){
                        self.selectedFieldDropdowns = self.followupFieldOptions.map(field => { return {
                            followup_field_id : field.id,
                            followup_field_label : field.name,
                        }})
                    }else{
                        self.selectedFieldDropdowns = self.agaveFieldOptions.map(field => { return {
                            agave_field_id : field.id,
                            agave_field_label: field.name,
                        }})
                    }



                    //re-assigning the dropdownMapping data to existing options from DB
                    if(self.selectedFieldItem.dropdownMappings.length > 0){
                        // self.selectedFieldDropdowns = self.selectedFieldItem.dropdownMappings;
                        self.selectedFieldDropdowns = self.selectedFieldDropdowns.map(moduleFieldDropdown => {
                            let matchedDropdown = self.selectedFieldItem.dropdownMappings.find(dropdown => (dropdown.followup_field_id == moduleFieldDropdown.followup_field_id || dropdown.agave_field_id == moduleFieldDropdown.agave_field_id))
                            if(matchedDropdown){
                                return {
                                    followup_field_id: matchedDropdown.followup_field_id,
                                    followup_field_label: matchedDropdown.followup_field_label,
                                    agave_field_id: matchedDropdown.agave_field_id,
                                    agave_field_label: matchedDropdown.agave_field_label
                                }

                            }else{
                                return moduleFieldDropdown;
                            }
                        })
                    }



                    $("#loadingOverlayFetchFieldOptions").fadeOut();
                }
            });

            setTimeout(() => {
                $("#loadingOverlayFetchFields").fadeOut();
            }, 3000)

        },
        changeDropdownMappingField(fieldIndex, option, type){
            if(type == 'follow_up'){
                option.followup_field_label = this.followupFieldOptions.find(followUpOption => followUpOption.id == option.followup_field_id)?.name ?? ''
            }else{
                option.agave_field_label = this.agaveFieldOptions.find(thirdPartyOption => thirdPartyOption.id == option.agave_field_id)?.name ?? ''
            }
        },

        saveDropdownOptions() {
            let self = this;
            // if(self.selectedFieldDropdowns.some(selectedFieldDropdowns => !selectedFieldDropdowns.followup_field_id || !selectedFieldDropdowns.agave_field_id)){
            //     this.getToast(2000).fire({
            //         type: 'error',
            //         title: 'Some fields are not mapped'
            //     });
            //     return false;
            // }else{
                this.selectedFieldItem.dropdownMappings = self.selectedFieldDropdowns.filter(option => option.followup_field_id && option.agave_field_id); // keeping only mapped options
                // self.modules[self.selectedModuleIndex].fieldMappings[self.selectedFieldIndex].dropdownMappings = this.selectedFieldItem.dropdownMappings;
                self.dropDownOptionsModal = false;
                self.followupFieldOptions = [];
                self.agaveFieldOptions = [];
                self.selectedFieldDropdowns = [];
                self.showSaveFieldsButton = true;
            // }
        },
        // to set the field mapping modal
        async viewFieldsMapping(item, index){
            let self = this;
            self.addToolTip();
            self.showFieldsMapping = true;
            self.fieldMappingError = null;
            self.fieldMappingNote = '';
            self.loadingMessage = 'Fetching fields';

            if(!item.followUp || !item.thirdParty){
                self.selectedModuleFields = []
                self.fieldMappingError = 'Modules are required';
                return false;
            }
            self.$nextTick(() => {
                $("#loadingOverlayFetchFields").fadeIn();
            })
            this.selectedModule = item;
            this.selectedModule.directionUrl = this.returnUrl(item.direction+'-latest');
            this.selectedModuleIndex = index;
            if(this.selectedModule.followUp === 'Project'){

                this.followUpFieldsOptions = [{
                    label: 'Project Fields',
                    options: this.projectFields
                },
                {
                    label: 'Project Contact',
                    options: this.projectContactFields
                },
                {
                    label: 'Custom Fields',
                    options: this.projectCustomFields
                },
                {
                    label: 'Record Details Custom Fields',
                    options: this.recordDetailCustomFields
                },
                {
                    label: 'Sales Behaviors',
                    options: this.projectSalesBehaviors
                }]
                // this.followUpFieldsOptions = [...this.projectFields, ...customFieldOptions];
            }else if(this.selectedModule.followUp === 'Residential-contact'){
                this.followUpFieldsOptions = [{
                    label: 'Contact Fields',
                    options: [...this.contactFields, ...this.residentialContactFields]
                }, {
                    label: 'Custom Fields',
                    options: this.contactCustomFields
                }];
            }else if(this.selectedModule.followUp === 'Company'){
                this.followUpFieldsOptions = [{
                    label: 'Company Fields',
                    options: this.companyFields
                }, {
                    label: 'Company Custom Fields',
                    options: this.companyCustomFields
                }, {
                    label: 'Contact Fields',
                    options: this.contactFields
                }, {
                    label: 'Contact Custom Fields',
                    options: this.contactCustomFields
                }];
            }else if(this.selectedModule.followUp === 'Project-change-order'){
                this.followUpFieldsOptions = [{
                    label: 'Change Order',
                    options: this.projectChangeOrderFields
                }, {
                    label: 'Custom Fields',
                    options: this.changeOrderCustomFields
                }];
            }


            if(this.selectedModule.followUp === 'Project'){
                this.thirdPartyFieldsOptions = [{
                    label: 'Project Fields',
                    options: await this.getThirdPartyFields(item.thirdParty, 'Project')
                }]
            }else if(this.selectedModule.followUp === 'Company' || this.selectedModule.followUp === 'Residential-contact'){
                this.thirdPartyFieldsOptions = [{
                    label: 'Customer Fields',
                    options: await this.getThirdPartyFields('MASTER_ARM_RECORD_1', 'Customer')
                }, {
                    label: 'Contact Fields',
                    options: await this.getThirdPartyFields('STANDARD_ARS_RECORD_1', 'Contact', false)
                }]
            }else if(this.selectedModule.followUp === 'Project-change-order'){
                this.thirdPartyFieldsOptions = [{
                    label: 'Change Order Fields',
                    options: await this.getThirdPartyFields(item.thirdParty, 'Change_Order')
                }]
            }

            this.setModuleFields();

            if(self.selectedModule.thirdParty && self.selectedModule.followUp){
                const requiredFields = self.agaveFields[self.selectedModule.thirdParty].filter(field => field.required);
                if(requiredFields && requiredFields.length > 0){
                    self.fieldMappingNote = 'Note: Required fields by Sage 300 CRE ('+ requiredFields.map(field => (field.description || field.label)).join(", ")+')';
                }
            }

            $("#loadingOverlayFetchFields").fadeOut();

        },

        async getThirdPartyFields(tableName, type, showMessage = true) {
            let self = this;
            try {
                let fieldsArr = [];
                let payload = {
                    'tableName': tableName,
                };

                const { data } = await axios.post(route('api.erp-integration-sage300-fields.get'), payload);

                if(data.message && showMessage){
                    self.getToast(4000).fire({
                        type: 'error',
                        title: data.message

                    });
                }else if (data.thirdPartyKeys) {
                    const fieldsFromAgave = this.agaveFields[tableName] ?? [];
                    data.thirdPartyKeys.forEach(key => {
                        const matchingField = type == 'Contact' ? fieldsFromAgave.reverse().find(field => field.label === key)
                                                                : fieldsFromAgave.find(field => field.label === key);   // customer and contact fields for email and phone etc are having same key_name so I'm reversing the agaveList for contacts so it pick contact field matching as contact fields are at the bottom
                        let isTwoWay = !!(matchingField && matchingField.direction == 'two-ways');

                        fieldsArr.push({
                            value: matchingField ? matchingField.value : key,
                            label: key,
                            description: this.getSafe(() => matchingField.description) || key,
                            agave_object_type: type,
                            disabled: false,
                            direction: isTwoWay ? 'two-ways' : 'one-way-followup',
                            canChangeDirection: isTwoWay ? true : false,
                        });
                    });

                    // if (tableName != 'Project-change-order') {
                    //     fieldsArr.push({
                    //         value: 'start_date',
                    //         label: 'StartDate',
                    //         description: 'Start Date',
                    //         disabled: false,
                    //         direction: 'two-ways'
                    //     });
                    // }

                    // fieldsArr.sort((a, b) => a.description.localeCompare(b.description));
                }

                return fieldsArr;
            } catch (error) {
                console.error('Error fetching third party fields:', error);
                throw error;
            }
        },

        setModuleFields(){
            this.selectedModuleFields = [];
            const requiredFields = this.agaveFields[this.selectedModule.thirdParty].filter(field => field.required);

            if(this.selectedModule.fieldMappings.length > 0) {
                this.selectedModule.fieldMappings.map(mappedField => {
                    this.selectedModuleFields.push({
                        erp_integration_field_id: mappedField.erp_integration_field_id,
                        id: mappedField.id,
                        followUp: mappedField.followUp,
                        followUpLabel: mappedField.followUpLabel,
                        followUpObject: mappedField.followUpObject,
                        direction: mappedField.direction,
                        thirdPartyLabel: mappedField.thirdPartyLabel,
                        thirdParty: mappedField.thirdParty,
                        status: !!mappedField.status,
                        is_custom_field: !!mappedField.is_custom_field,
                        is_record_detail_custom_field: !!mappedField.is_record_detail_custom_field,
                        agave_object_type: mappedField.agave_object_type,
                        is_custom_field_synced: !!mappedField.is_custom_field_synced,
                        canChangeDirection: this.userCanChangeDirection(mappedField),
                        dropdownMappings: mappedField.dropdownMappings ?? [],
                        directionUrl: this.returnUrl(mappedField.direction+'-latest'),
                        is_dropdown_field: mappedField?.is_dropdown_field ?? this.isDropDownField(mappedField),
                        is_third_party_dropdown_field: mappedField?.is_third_party_dropdown_field ?? this.isThirdPartyDropdownField(mappedField)
                    })
                });

                const missingRequiredFields = requiredFields
                    .filter(obj1 => !this.selectedModule.fieldMappings.some(obj2 => obj1.value === obj2?.thirdParty))
                    .map(obj => obj.value);

                const finalRequiredFields = requiredFields.filter(field => missingRequiredFields.includes(field.value));
                this.manageSage300RequiredFieldSelection(finalRequiredFields);
            }
            else {
                if(requiredFields.length > 0) {
                    this.manageSage300RequiredFieldSelection(requiredFields);
                }
            }
        },
        userCanChangeDirection(fieldItem){
            if(this.selectedModule.followUp == 'Project-change-order'){
                return false;
            }else{
                return !!this.agaveFields[this.selectedModule.thirdParty].some(field => (field.label === fieldItem.thirdPartyLabel || field.label === fieldItem.third_party_field) && field.direction == 'two-ways');
                // return !!this.agaveFields[this.selectedModule.thirdParty].some(field => field.value === fieldItem.agave_field);
            }
        },

        // to add new row to erpIntegration modules
        async addModuleMappingData() {
            const self = this;
            await self.disabledOption(self.modules)
            const followUpResult = await self.followupObjectOption.filter(val => val.disabled !== true);
            if(followUpResult.length > 0){
                await self.modules.push({
                    erp_integration_id: self.erpIntegrationId,
                    id: 0,
                    followUp: null,
                    followUpCustomId: null,
                    direction: this.direction,
                    thirdParty: null,
                    thirdPartyCustomId: null,
                    thirdPartyLabel: null,
                    status: false,
                    fieldMappings: []
                })
            }

            self.applyToolTip();
        },

        // to add new row to module field mappings
        async addModuleFieldMappingData() {
            const self = this;
            await self.disabledFieldOption(self.selectedModuleFields)
            const followUpFieldResult = self.computedFollowUpFieldsOptions.filter(val => val.disabled !== true);
            const thirdPartyFieldResult = self.computedThirdPartyFieldsOptions.filter(val => val.disabled !== true);
            if(followUpFieldResult.length > 0 && thirdPartyFieldResult.length > 0){
                self.selectedModuleFields.push({
                    erp_integration_field_id: self.selectedModule.id,
                    id: 0,
                    followUp: {value: null, label: null, object_type: null, disabled: false, is_custom_field: 0, is_record_detail_custom_field: 0},
                    followUpLabel: null,
                    followUpObject: null,
                    direction: this.fieldDirection,
                    thirdPartyLabel: null,
                    thirdParty: null,
                    status: true,
                    is_custom_field: false,
                    is_record_detail_custom_field: false,
                    agave_object_type: null,
                    is_custom_field_synced: false,
                    dropdownMappings:[],
                })
            }
        },

        // to save/create an erp module in DB
        saveModule(data) {
            // if(data.fieldMappings.length > 0){
                const self = this;
                self.isAddButtonDisabled = true;
                let payload =  {
                    erp_integration_id : self.erpIntegrationId,
                    data:data
                }
                axios.post(route('api.erp-integration-fields.create'), payload).then(({data}) => {
                    self.getErpIntegrations();
                    self.isAddButtonDisabled = false;
                    this.applyToolTip();
                });
            // }
        },

        // to update the erp module fields in DB
        async updateModule(data) {
            const self = this;
            let payload =  {
                data: data
            }
            await axios.post(route('api.erp-integration-fields.update-vista-module'), payload).then(({data}) => {
                self.getErpIntegrations();
                this.showSaveFieldsButton = false;
                if (self.fieldMappingError === null){
                    self.getToast(3000).fire({
                        type: 'success',
                        title: self.formatERPModuleName(self.selectedModule.followUp) + ' mapping successfully saved'
                    });
                }
            });
        },

        // to complete adding the module field to selectedModuleFields
        async addModuleField(index) {
            const fieldObject = this.selectedModuleFields[index];
            if(!fieldObject.followUp?.value || !fieldObject.thirdParty){
                this.fieldMappingError = 'Please map a field on both sides in order to save.';
                return false;
            }

            this.selectedModuleFields[index].id = index+1;
            await this.disabledFieldOption(this.selectedModuleFields)

            if(!this.showSaveFieldsButton){
                this.showSaveFieldsButton = true;
            }
            this.fieldMappingError = null;
            this.editingModuleFieldIndex = false
        },

        onModalClose() {
            this.addToolTip();
            if (this.showFieldsMapping) {
                this.saveModuleFields();
            }
        },

        // to push the module field to module.fieldMappings
        async saveModuleFields() {
            let self = this;

            // const requiredFields = self.agaveFields[this.selectedModule.thirdParty].filter(field => field.required);
            //
            // const unmappedRequiredFields = requiredFields.filter(requiredField => {
            //     return !self.selectedModuleFields.some(mapping => mapping.thirdPartyLabel === requiredField.label);
            // });

            // if(self.selectedModuleFields.some(mapping => (!mapping.followUpLabel || !mapping.thirdPartyLabel))){
            //     this.fieldMappingError = 'Some fields are not mapped';
            // }else if (unmappedRequiredFields.length > 0) {
            //     this.fieldMappingError = '* Missing required fields Sage 300 CRE ('+ unmappedRequiredFields.map(field => (field.description || field.label) ).join(", ")+')';
            // } else {
                self.modules[self.selectedModuleIndex].fieldMappings = self.selectedModuleFields.filter(field => field.followUpLabel && field.thirdPartyLabel);

                self.showFieldsMapping = false;
                self.selectedModuleFields = [];
                // await self.disabledFieldOption(self.selectedModuleFields);
                if(self.modules[self.selectedModuleIndex].id !== 0) {
                    self.modules[self.selectedModuleIndex].status = self.checkMappedModuleStatus(self.selectedModule);
                    await self.updateModule(self.modules[self.selectedModuleIndex]);
                }

                this.editingModuleFieldIndex = null;
            // }
        },

        // to delete the module form DB
        async deleteModule(item) {
            let self = this;
            let payload =  {
                    erp_integration_id : self.erpIntegrationId,
                    field_id : item.id
                }
            await axios.post(route('api.erp-integration-fields.delete'), payload).then(async ({data}) => {
                await self.getErpIntegrations(item.id);
                // await self.getAllErp();
                // self.showButtonMapping = true;
                const objectOptionIndex = self.followupObjectOption.findIndex(val => val.value === item.followUp);
                if(objectOptionIndex !== -1){
                    self.followupObjectOption[objectOptionIndex].disabled = false;
                }
            });
        },

        // to remove the module field from selectedModuleFields while editing
        async removeModuleField(index) {
            await this.removeDisabledFieldOption(this.selectedModuleFields[index]);
            this.selectedModuleFields.splice(index, 1);
            this.showSaveFieldsButton = true;
            this.editingModuleFieldIndex = null;
        },

        returnUrl(val){
            return this.bucketUrl+'erp/'+val+'.png'
        },

        returnToolTip(val){
            let msg = 'Message';
            if (val === 'one-way-followup'){
                msg = 'The individual field mapping direction cannot be changed as the main module direction is set to One way - Sage 300 to Followup';
            }
            if (val === 'one-way-third-party'){
                msg = 'The individual field mapping direction cannot be changed as the main module direction is set to One way - Followup To Sage 300';
            }
            return msg;
        },

        returnUrlDirection(val){
            if (val === 'two-ways' || val === 'one-way-followup' || val === 'one-way-third-party'){
                this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'-latest.png';
            }else {
                this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'.png';
            }
            $('#directionModuleUrl').attr('src', this.selectedModule.directionUrl);
        },

        returnUrlHover(val){
            this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'-hover.png';
            $('#directionModuleUrl').attr('src', this.selectedModule.directionUrl);
        },

        returnUrlDirectionField(val, index){
            if (val.direction === 'two-ways' || val.direction === 'one-way-followup' || val.direction === 'one-way-third-party'){
                val.directionUrl = this.bucketUrl+'erp/'+val.direction+'-latest.png';
            }else {
                val.directionUrl = this.bucketUrl+'erp/'+val.direction+'.png';
            }
            $('#directionModuleUrlField'+val.id+'-'+index).attr('src', val.directionUrl);
        },
        returnUrlHoverField(val, index){
            val.directionUrl = this.bucketUrl+'erp/'+val.direction+'-hover.png';
            $('#directionModuleUrlField'+val.id+'-'+index).attr('src', val.directionUrl);
        },

        // to change the direction of the module FollowUp to ThirdParty etc.
        changeModuleDirection(){
            if(this.selectedModule.followUp == 'Project-change-order'){
                this.selectedModule.direction = 'one-way-followup';
                this.getToast().fire({
                    type: 'error',
                    title: 'Pushing Change orders to Sage 300 is not currently supported'

                });
                return;
            }else{
                switch (this.selectedModule.direction) {
                    case 'two-ways':
                        this.selectedModule.direction = 'one-way-followup';
                        break;
                    case 'one-way-followup':
                        this.selectedModule.direction = 'one-way-third-party';
                        break;
                    case 'one-way-third-party':
                        this.selectedModule.direction = 'two-ways';
                        break;
                    default:
                        console.log(`Sorry, we are out`);
                }
            }

            this.returnUrlDirection(this.selectedModule.direction);
            this.showSaveFieldsButton = true;

            this.selectedModuleFields = _.map(this.selectedModuleFields, mappedField => {
                mappedField.direction = this.userCanChangeDirection(mappedField) ? this.selectedModule.direction : mappedField.direction;
                mappedField.canChangeDirection = this.userCanChangeDirection(mappedField);
                mappedField.directionUrl = this.userCanChangeDirection(mappedField) ? this.returnUrl(this.selectedModule.direction + '-latest') : this.returnUrl(mappedField.direction + '-latest');
                return mappedField;
            });


            this.applyToolTip();
        },

        // to change the direction of the module fields if the field has agave key
        changeModuleFieldDirection(fieldItem, index){
            if(fieldItem.followUpObject == "ProjectChangeOrder"){
                this.getToast().fire({
                    type: 'error',
                    title: 'Pushing Change orders to Sage 300 is not currently supported'

                });
                return;
            }else{
                switch (fieldItem.direction) {
                    case 'two-ways':
                        fieldItem.direction = 'one-way-followup';
                        break;
                    case 'one-way-followup':
                        fieldItem.direction = 'one-way-third-party';
                        break;
                    case 'one-way-third-party':
                        fieldItem.direction = 'two-ways';
                        break;
                    default:
                        console.log(`Sorry, we are out`);
                }
            }

            this.returnUrlDirectionField(fieldItem, index);
            this.showSaveFieldsButton = true;
            this.applyToolTip();
        },

        updateFieldStatus(item){
            let payload =  {
                    status : !item.status,
                    erp_integration_field_id : item.id,
                    erp_integration_id : item.erp_integration_id,
                }
                if(item.id == 0){
                    return false
                }
            axios.post(route('api.erp-integration-fields.update'), payload).then(({data}) => {
            });
        },

        isRequiredFieldsMapped(data){
            return !this.checkMappedModuleStatus(data);
        },

        async getErpIntegrations(deletedModuleId = null){
            const self = this;
            await axios.get(route('api.erp-integration.get',{third_party_name: 'sage-300-cre'})).then( async ({data}) => {
                if(data){
                    self.erpIntegrationId = data.id;
                    self.direction = data.direction
                    self.selectedSourceTruth = data.source_truth
                    self.syncStatus = data.sync_status

                    if(self.modules.length > 0){


                        self.modules = self.modules
                            .filter(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                return !!matchedField; // Only include objects where a matching field is found
                            })
                            .map(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                const parsedFieldJson = JSON.parse(matchedField.field_json);

                                moduleMap.erp_integration_id = matchedField.erp_integration_id;
                                moduleMap.id = matchedField.id;
                                moduleMap.followUp = matchedField.follow_up_object;
                                moduleMap.followUpCustomId = this.getSafe(() => parsedFieldJson.followUpCustomId);
                                moduleMap.direction = matchedField.direction;
                                moduleMap.thirdParty = matchedField.third_party_object;
                                moduleMap.thirdPartyCustomId = this.getSafe(() => parsedFieldJson.thirdPartyCustomId);
                                moduleMap.thirdPartyLabel = matchedField.third_party_label;
                                moduleMap.status = !!matchedField.status;
                                moduleMap.fieldMappings = matchedField.module_fields ? this.formatModuleFields(matchedField.module_fields, parsedFieldJson) : [];

                                return moduleMap;
                            });


                    }else{
                        self.modules = await data.fields.map(val => {
                            const parsedFieldJson = JSON.parse(val.field_json);
                            return {
                                erp_integration_id: val.erp_integration_id,
                                id: val.id,
                                followUp: val.follow_up_object,
                                followUpCustomId: this.getSafe(() => parsedFieldJson.followUpCustomId),
                                direction: val.direction,
                                thirdParty: val.third_party_object,
                                thirdPartyCustomId: this.getSafe(() => parsedFieldJson.thirdPartyCustomId),
                                thirdPartyLabel: val.third_party_label,
                                status: !!val.status,
                                fieldMappings: val.module_fields ? this.formatModuleFields(val.module_fields, parsedFieldJson) : []
                            }
                        })
                    }

                    // await self.disabledOption(data.fields)
                }

            });
        },
        formatModuleFields(moduleMappings, parsedJson = null){
            return moduleMappings.map(moduleMapping => {
                let matchedField = null;
                if(parsedJson){
                    matchedField = parsedJson.fieldMappings.find(field => field.thirdParty == moduleMapping.agave_field && field.thirdPartyLabel == moduleMapping.third_party_field && field.followUp.value == moduleMapping.follow_up_field)
                }
                return {
                    agave_object_type: moduleMapping.agave_object_type,
                    erp_integration_field_id: moduleMapping.erp_integration_field_id,
                    id: moduleMapping.id,
                    followUp: {value: moduleMapping.follow_up_field,
                        label: moduleMapping.follow_up_field_label,
                        object_type: moduleMapping.follow_up_object_type,
                        disabled: false,
                        is_custom_field: !!moduleMapping.is_custom_field,
                        // fieldType: matchedField?.followUp?.fieldType ?? null,
                        is_sales_behavior: matchedField ?
                            ((matchedField.followUp.is_sales_behavior && matchedField.followUp.is_sales_behavior != 0) ? matchedField.followUp.is_sales_behavior : false) :
                            ((moduleMapping.is_sales_behavior && moduleMapping.is_sales_behavior != 0) ? moduleMapping.is_sales_behavior : false),
                        is_project_contact: matchedField ?
                            ((matchedField.followUp.is_project_contact && matchedField.followUp.is_project_contact != 0) ? matchedField.followUp.is_project_contact : false) :
                            ((moduleMapping.is_project_contact && moduleMapping.is_project_contact != 0) ? moduleMapping.is_project_contact : false),
                        is_project_comment: matchedField ?
                            ((matchedField.followUp.is_project_comment && matchedField.followUp.is_project_comment != 0) ? matchedField.followUp.is_project_comment : false) :
                            ((moduleMapping.is_project_comment && moduleMapping.is_project_comment != 0) ? moduleMapping.is_project_comment : false),
                        is_record_detail_custom_field: !!moduleMapping.is_record_detail_custom_field,
                    },
                    followUpLabel: moduleMapping.follow_up_field_label,
                    followUpObject: moduleMapping.follow_up_object_type,
                    direction: moduleMapping.direction,
                    thirdPartyLabel: moduleMapping.third_party_field,
                    thirdParty: moduleMapping.agave_field,
                    status: moduleMapping.status,
                    is_custom_field: moduleMapping.is_custom_field,
                    is_third_party_dropdown_field: matchedField? matchedField.is_third_party_dropdown_field : false,
                    is_custom_field_synced: false,
                    is_dropdown_field: matchedField? matchedField.is_dropdown_field : false,
                    dropdownMappings: matchedField?.dropdownMappings ?? [],
                    is_record_detail_custom_field: moduleMapping.is_record_detail_custom_field,
                }
            })
        },
        disabledOption(data) {
            // let self = this;
            // self.followupObjectOption = self.followupObjectOption.map(option => ({...option, disabled: false}));
            // self.thirdPartyObjectOptions = self.thirdPartyObjectOptions.map(option => ({...option, disabled: false}));
            // data.map(item => {
            //     const followUpOptionIndex = self.followupObjectOption.findIndex(option => option.custom_id === item.followUpCustomId)
            //     if(followUpOptionIndex !== -1){
            //         self.followupObjectOption[followUpOptionIndex].disabled = true
            //     }
            //     const thirdPartyOptionIndex = self.thirdPartyObjectOptions.findIndex(thirdPartyOption => thirdPartyOption.custom_id === item.thirdPartyCustomId)
            //     if(thirdPartyOptionIndex !== -1){
            //         self.thirdPartyObjectOptions[thirdPartyOptionIndex].disabled = true
            //     }
            // })
        },

        disabledFieldOption(data){
            // this.thirdPartyFieldsOptions = this.thirdPartyFieldsOptions.map(option => ({...option, disabled: false}));
            // for (let j = 0; j < data.length; j++) {

            //     const thirdPartyFieldOptionIndex = this.thirdPartyFieldsOptions.findIndex(item => item.value === data[j].thirdParty);
            //     if(thirdPartyFieldOptionIndex !== -1){
            //         this.thirdPartyFieldsOptions[thirdPartyFieldOptionIndex].disabled = true;
            //     }
            // }
        },

        removeDisabledFieldOption(data){
            // const followupFieldOptionIndex = this.followUpFieldsOptions.findIndex(item => item.value === data.followUp);
            // if(followupFieldOptionIndex !== -1){
            //     this.followUpFieldsOptions[followupFieldOptionIndex].disabled = false;
            // }
            // const thirdPartyFieldOptionIndex = this.thirdPartyFieldsOptions.findIndex(item => item.value === data.thirdParty);
            // if(thirdPartyFieldOptionIndex !== -1){
            //     this.thirdPartyFieldsOptions[thirdPartyFieldOptionIndex].disabled = false;
            // }
        },

        changeModules(data, type, index){
            if(type === 'followup'){
                if((data.followUp === 'Project' && data.thirdParty && data.thirdParty !== 'MASTER_JCM_RECORD_1')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Project can only be mapped to Job Cost'
                    });
                    this.modules[index].followUp = null;
                    this.modules[index].followUpCustomId = null;
                }else if((data.followUp === 'Residential-contact' && data.thirdParty && data.thirdParty !== 'STANDARD_ARS_RECORD_1')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Residential Contact can only be mapped to Accounts Receivable (for Residential Contact)'
                    });
                    this.modules[index].followUp = null;
                    this.modules[index].followUpCustomId = null;
                }else if((data.followUp === 'Company' && data.thirdParty && data.thirdParty !== 'MASTER_ARM_RECORD_1')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Company can only be mapped to Accounts Receivable (for Company)'
                    });
                    this.modules[index].followUp = null;
                    this.modules[index].followUpCustomId = null;

                }else{
                    this.modules[index].followUp = data.followUp;
                    this.modules[index].followUpCustomId = this.followupObjectOption.find(option => option.value === data.followUp).custom_id;
                }
            }else{

                if((data.thirdParty === 'MASTER_JCM_RECORD_1' && data.followUp && data.followUp !== 'Project')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Job Cost can only be mapped to Project'
                    });
                    this.modules[index].thirdParty = null;
                    this.modules[index].thirdPartyCustomId = null;
                }else if((data.thirdParty === 'STANDARD_ARS_RECORD_1' && data.followUp && data.followUp !== 'Residential-contact')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Accounts Receivable (for Residential Contact) can only be mapped to Residential Contact'
                    });
                    this.modules[index].thirdParty = null;
                    this.modules[index].thirdPartyCustomId = null;
                }else if((data.thirdParty === 'MASTER_ARM_RECORD_1' && data.followUp && data.followUp !== 'Company')){
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Accounts Receivable (for Company) can only be mapped to Company'
                    });
                    this.modules[index].thirdParty = null;
                    this.modules[index].thirdPartyCustomId = null;
                }else{
                    this.modules[index].thirdParty = data.thirdParty;
                    this.modules[index].thirdPartyCustomId = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty && !option.disabled).custom_id;
                    this.modules[index].thirdPartyLabel = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty).label;

                }
            }
            this.disabledOption(this.modules);

            if (data.thirdParty != null && data.followUp != null) {
                data.direction = data.followUp === 'Project-change-order' ? 'one-way-followup' : 'two-ways';
                this.saveModule(data);
            }
        },
        changeFields(data, type, index){

            let self = this;
            if(type == 'followup'){
                if(data.thirdParty && data.thirdParty === '_idnum' && data.followUp && data.followUp.value == 'id'){
                    self.getToast(3000).fire({
                        type: 'error',
                        title: "Project Seq ID/Custom # can't be mapped to Agave ID"
                    });
                    this.resetField(data, type);
                    return false;
                }
            }else{
                if(data.followUp && data.followUp.value == 'id' && data.thirdParty && data.thirdParty === '_idnum'){
                    self.getToast(3000).fire({
                        type: 'error',
                        title: "Agave ID can't be mapped to Project Seq ID/Custom #"
                    });
                    this.resetField(data, type);
                    return false;
                }
            }


            if(type === 'followup'){
                let followUpSelectedOption = data.followUp;
                this.selectedModuleFields[index].is_custom_field = followUpSelectedOption.is_custom_field;
                this.selectedModuleFields[index].is_record_detail_custom_field = followUpSelectedOption.is_record_detail_custom_field;
                // this.selectedModuleFields[index].followUp = data.followUp;
                this.selectedModuleFields[index].followUpLabel = followUpSelectedOption.label;
                this.selectedModuleFields[index].followUpObject = followUpSelectedOption.object_type;
            }else{
                const thirdPartySelectedOption = this.computedThirdPartyFieldsOptions.find(option => option.value === data.thirdParty)
                this.selectedModuleFields[index].thirdParty = data.thirdParty;
                this.selectedModuleFields[index].thirdPartyLabel = thirdPartySelectedOption.label;
                this.selectedModuleFields[index].direction = thirdPartySelectedOption.direction;
                this.selectedModuleFields[index].canChangeDirection = thirdPartySelectedOption.canChangeDirection;
                this.selectedModuleFields[index].agave_object_type = thirdPartySelectedOption.agave_object_type;
                this.selectedModuleFields[index].directionUrl = this.returnUrl(thirdPartySelectedOption.direction+'-latest');
            }
            this.fieldMappingError = null;
            this.disabledFieldOption(this.selectedModuleFields);

            /**
             *
                Applying this Check because In Sage300, If we try to updateCompanyInfo from Agave and we choose multiple Contacts in updateForm
                while Contact fields are mapped to customer fields in mapping, then we cannot know which contact's data to be used to update followupCompany object
             *
             * */
             if (this.selectedModule.followUp == 'Company' && data.agave_object_type && data.followUp.object_type) {
                if ((data.agave_object_type == 'Customer' && data.followUp.object_type != 'Company') || (data.agave_object_type != 'Customer' && data.followUp.object_type == 'Company')) {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Company Fields can only be mapped to Customer Fields.'
                    });
                    this.resetField(data, type);
                }
                else if ((data.agave_object_type == 'Contact' && data.followUp.object_type != 'CompanyContact') || (data.agave_object_type != 'Contact' && data.followUp.object_type == 'CompanyContact')) {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Contact Fields can only be mapped to Contact Fields.'
                    });
                    this.resetField(data, type);
                }
            }

        },
        resetField(field, type){
            if(type === 'followup'){
                field.is_custom_field = false;
                field.is_record_detail_custom_field = false;
                field.followUp = {value:null,label:null,object_type:null,disabled:false,is_custom_field:0, is_record_detail_custom_field: 0};
                field.followUpLabel = null;
                field.followUpObject = null;
            }else{
                field.thirdParty = null;
                field.thirdPartyLabel = null;
                field.direction = "two-ways";
                field.canChangeDirection = false;
                field.agave_object_type = null;
            }
        },
        getProjectCustomFields(){
            let self = this;
            let params = `?project=true`;
            axios.get(route('api.project-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                        self.projectCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, is_record_detail_custom_field: false, fieldType: field.type, object_type: 'Project',is_dropdown_field : !! [1,3].includes(field.type) });
                    })
                }

            });
        },
        getCompanyCustomFields(){
            let self = this;
            let params = `?company=true`;
            axios.get(route('api.company-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                        self.companyCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, is_record_detail_custom_field: false, object_type: 'Company',is_dropdown_field : !! [1,3].includes(field.type) });
                    })
                }
            });
        },
        getContactCustomFields(){
            let self = this;
            let params = `?contact=true`;
            axios.get(route('api.contact-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                            self.contactCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, is_record_detail_custom_field: false, object_type: 'CompanyContact',is_dropdown_field : !! [1,3].includes(field.type) });
                    })
                }
            });
        },
        editModuleField(index){
            this.editingModuleFieldIndex = index;
        },
        openImportCustomersModal(item){
            this.selectedModuleForImport = item.followUp;
            $("#importCustomerConfirmationModal").modal('show');
        },
        importCustomers(){

            $("#importCustomerConfirmationModal").modal('hide');
            let self = this;
            axios.post(route('api.sage300.import-customers', {type: this.selectedModuleForImport})).then(response => {
                if(response.data.status == "success"){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong'

                    });
                }
            });

        },
        closeImportCustomersModal(){
            $("#importCustomerConfirmationModal").modal('hide');
        },
        isFieldDisabled(selectedModuleFields, option){
            // let isDisabled = option.disabled;
            // selectedModuleFields.map(fieldMapping => {
            //     if(fieldMapping.followUpLabel && fieldMapping.followUp.label == option.label && fieldMapping.followUp.object_type == option.object_type){
            //         isDisabled = true;
            //     }
            // })
            // return isDisabled;
        },
        isDropDownField(fieldItem) {
            let allOptions = this.followUpFieldsOptions.reduce((accumulator, currentValue) => {
                return accumulator.concat(currentValue.options);
            }, []);
            let selectedField = _.find(allOptions, option => (option.label == fieldItem.followUpLabel));
            return selectedField ? selectedField.is_dropdown_field : false;
        },
        formattedLabel(fieldItem) {
            let label = fieldItem.thirdPartyLabel.replace(/_/g, ' ');
            label = label.replace(/([A-Z])(?=[a-z])/g, ' $1').replace(/([a-z])(?=[A-Z])/g, '$1 ').trim()
            return label;
        },
        getSalesBehaviors() {
            let self = this;
            axios.get(route('api.erp-integration.get-sales-behaviors')).then(({data}) => {
                if(data.data.length){
                    data.data.map(salesBehavior =>{
                        self.projectSalesBehaviors.push({
                            id:salesBehavior.id,
                            label: salesBehavior.name,
                            value: salesBehavior.id,
                            object_type:'Project',
                            disabled: false,
                            is_dropdown_field: false,
                            is_sales_behavior:true
                        });
                    });
                }

            });
        },
        isThirdPartyDropdownField(item) {
            return !!this.thirdPartyFieldsOptions.some(field => field.value === item.third_party_field && field.is_dropdown_field);
        },
        getRecordDetailCustomFields() {
            let self = this;
            let params = `?project=true`;
            axios.get(route('api.record-detail-custom-field.index') + params).then(({data}) => {
                if(data.data.length) {
                    data.data.map(field => {
                        self.recordDetailCustomFields.push({
                            value: field.id,
                            label: field.label_value,
                            disabled: false,
                            is_record_detail_custom_field: true,
                            fieldType: field.type,
                            object_type: 'Project',
                            is_dropdown_field : !![1,3].includes(field.type)
                        });
                    });
                }
            });
        },
        manageSage300RequiredFieldSelection(requiredFields) {
            let formattedObject = {
                id: 0,
                is_custom_field: false,
                is_record_detail_custom_field: false,
                is_custom_field_synced: false,
                is_dropdown_field: false,
                followUpLabel: null,
                followUpObject: null,
                followUp: {
                    value: null,
                    label: null,
                    object_type: null,
                    disabled: false,
                    is_custom_field: 0,
                    is_record_detail_custom_field: 0
                },
                erp_integration_field_id: this.selectedModule.id,
                status: true,
                dropdownMappings: []
            };

            requiredFields.forEach(field => {
                const thirdPartySelectedOption = this.computedThirdPartyFieldsOptions.find(option => option.value === field.value)
                this.selectedModuleFields.push({
                    ...formattedObject,
                    agave_object_type: thirdPartySelectedOption.agave_object_type,
                    thirdParty: field.value,
                    thirdPartyLabel: field.label,
                    is_third_party_dropdown_field: field.is_dropdown_field,
                    direction: thirdPartySelectedOption?.direction ?? 'two-ways',
                    canChangeDirection: thirdPartySelectedOption?.canChangeDirection ?? false,
                    directionUrl: this.returnUrl((thirdPartySelectedOption?.direction ?? 'two-ways') +'-latest')
                });
            });
        },
        isFieldRequired(item) {
            let self = this;
            let status = false;

            const result = _.find(self.agaveFields[self.selectedModule.thirdParty], { value: item.thirdParty });
            status = result?.required ? true : status;

            return status;
        },
        isFieldRequiredToolTip(item) {
            return this.manageFieldDisableForRequiredFields(item) ? 'Required field cannot be deleted' : '';
        },
        addToolTip() {
            setTimeout(() => {
                $(".tooltip-delete-field-mapping").tooltip('dispose');
                $(".tooltip-delete-field-mapping").tooltip();
            }, 2000);
        },
        manageModuleDeletion(module, index) {
            if(module.id === 0) {
                this.modules.splice(index, 1);
            }
            else {
                this.deleteModule(module);
            }
        },
        checkMappedModuleStatus(module) {
            if(module?.thirdParty) {
                const requiredFields = this.agaveFields[module.thirdParty].filter(field => field.required);
                if(requiredFields.length > 0) {
                    return requiredFields.every(obj1 =>
                        module.fieldMappings.some(obj2 => obj1.value === obj2.thirdParty)
                    );
                }
                else {
                    return module.fieldMappings.length > 0;
                }
            }
            return false;
        },
        manageFieldDisableForRequiredFields(fieldItem) {
            const fieldOccurrences = [];
            const selectedMappings = this.selectedModuleFields;

            selectedMappings.forEach((mapping, index) => {
                if(this.isFieldRequired(mapping)) {
                    fieldOccurrences.push({ field: mapping.thirdParty, index });
                }
            });

            // Find the first occurrence index for the current field
            const firstOccurrence = fieldOccurrences.find(
                occurrence => occurrence.field === fieldItem.thirdParty
            );

            // Disable button if the current field is the first occurrence
            return firstOccurrence && selectedMappings[firstOccurrence.index] === fieldItem;
        },
        getChangeOrderCustomFields() {
            let self = this;
            let params = `?changeOrder=true`;
            axios.get(route('api.change-order-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        self.changeOrderCustomFields.push({
                            value:field.id,
                            label: field.label_value,
                            disabled: false,
                            is_custom_field: true,
                            is_dropdown_field: [1,3].includes(field.type),
                            fieldType: field.type,
                            options: [],
                            object_type: 'ProjectChangeOrder'
                        });
                    });
                }
            });
        },
        syncSetting() {
            this.$refs.ErpSyncSetting.openSyncSettingModal();
        },
        syncSettingLogs() {
            this.$refs.ErpSyncSettingLogs.openSyncSettingLogsModal();
        },
    },
    computed: {
        computedFollowUpFieldsOptions() {

            return this.followUpFieldsOptions.map(group => ({
                label: group.label,
                options: group.options.map(option =>{
                    return {
                        value: {
                            value:option.value,
                            label: option.label,
                            object_type: option.object_type,
                            is_custom_field: option.is_custom_field ?? false,
                            is_sales_behavior: option.is_sales_behavior ?? false,
                            is_project_contact: option.is_project_contact ?? false,
                            is_project_comment: option.is_project_comment ?? false,
                            is_record_detail_custom_field: option.is_record_detail_custom_field ?? false,
                            // fieldType: option.fieldType ?? null,
                            disabled: false,
                        },
                        is_dropdown_field: option.is_dropdown_field,
                        label: option.label,
                        disabled: this.isFieldDisabled(this.selectedModuleFields, option),
                    }
                })
            }));
        },

        computedThirdPartyFieldsOptions() {
            return this.thirdPartyFieldsOptions.flatMap(group => group.options);
        },

    },
}
</script>
<style scoped>
#loadingOverlayFetchFields, #loadingOverlayFetchFieldOptions{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: none;
    background: rgb(0 0 0 / 57%);
}

.cv-spinner {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tooltips-direction-class {
    outline: none;
}
.spinner {
    width: 40px;
    height: 40px;
    border: 4px #ddd solid;
    border-top: 4px #2e93e6 solid;
    border-radius: 50%;
    animation: sp-anime 0.8s infinite linear;
}
img.and-logic-logo {
    width: 100%;
    max-width: 65px;
    height: auto;
    transition: all .3s linear;
    filter: invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(96%) contrast(106%);
}
@keyframes sp-anime {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}
.disabled-opacity {
    opacity: 0.7;
}
</style>
